/* 
  评卷教师评价
*/
import request from "@/utils/request";

//获取评卷教师评价页面参数
export function getParam() {
  return request({
    url: "/markteacher/markTchEvaluate/getParam",
    method: "get"
  });
}

//获取评卷教师评价分页列表
export function getMarkTchEvaluate(params) {
  return request({
    url: "/markteacher/markTchEvaluate/getMarkTchEvaluate",
    method: "get",
    params
  });
}

//手工评价
export function manualEvaluate(data) {
  return request({
    url: "/markteacher/markTchEvaluate/manualEvaluate",
    method: "post",
    data
  });
}

// 打印优秀教师证书 /markteacher/markTchEvaluate/printContract
export function printContract(data) {
  return request({
    // url: "/markteacher/markTchEvaluate/printContract", // 飞泉 学校端 接口地址 
    // url:window.config.baseUrl4Print+ "/markteacher/markTchEvaluate/printContract",  // 测试江辉 打印接口地址
    url:window.config.baseUrl4Shool+ "/markteacher/markTchEvaluate/printContract",  // 测试江辉 打印接口地址
    method: "post",
    responseType:"blob",
    data
  });
}

//加入黑名单
export function addBlackList(data) {
  return request({
    url: "/markteacher/markTchEvaluate/addBlackList",
    method: "post",
    data
  });
}

//移出黑名单
export function removeBlackList(data) {
  return request({
    url: "/markteacher/markTchEvaluate/removeBlackList",
    method: "post",
    data
  });
}
